var cov_1jvrv0avsp = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/tree.ts",
      hash = "d65335f2c8a34288ceca1cc5f4890aedfd7900c6",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/tree.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 30
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "1": {
        start: {
          line: 18,
          column: 32
        },
        end: {
          line: 35,
          column: 3
        }
      },
      "2": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 26
        }
      },
      "3": {
        start: {
          line: 19,
          column: 15
        },
        end: {
          line: 19,
          column: 26
        }
      },
      "4": {
        start: {
          line: 20,
          column: 16
        },
        end: {
          line: 20,
          column: 21
        }
      },
      "5": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 24,
          column: 5
        }
      },
      "6": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 46
        }
      },
      "7": {
        start: {
          line: 22,
          column: 26
        },
        end: {
          line: 22,
          column: 46
        }
      },
      "8": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 18
        }
      },
      "9": {
        start: {
          line: 25,
          column: 21
        },
        end: {
          line: 25,
          column: 102
        }
      },
      "10": {
        start: {
          line: 25,
          column: 100
        },
        end: {
          line: 25,
          column: 101
        }
      },
      "11": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 33,
          column: 5
        }
      },
      "12": {
        start: {
          line: 27,
          column: 18
        },
        end: {
          line: 27,
          column: 31
        }
      },
      "13": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 77
        }
      },
      "14": {
        start: {
          line: 28,
          column: 51
        },
        end: {
          line: 28,
          column: 77
        }
      },
      "15": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 41
        }
      },
      "16": {
        start: {
          line: 29,
          column: 30
        },
        end: {
          line: 29,
          column: 41
        }
      },
      "17": {
        start: {
          line: 30,
          column: 23
        },
        end: {
          line: 30,
          column: 87
        }
      },
      "18": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 73
        }
      },
      "19": {
        start: {
          line: 31,
          column: 52
        },
        end: {
          line: 31,
          column: 73
        }
      },
      "20": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 51
        }
      },
      "21": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 15
        }
      },
      "22": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 67
        }
      },
      "23": {
        start: {
          line: 36,
          column: 62
        },
        end: {
          line: 36,
          column: 66
        }
      },
      "24": {
        start: {
          line: 39,
          column: 31
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "25": {
        start: {
          line: 40,
          column: 21
        },
        end: {
          line: 40,
          column: 23
        }
      },
      "26": {
        start: {
          line: 41,
          column: 18
        },
        end: {
          line: 53,
          column: 3
        }
      },
      "27": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 52,
          column: 6
        }
      },
      "28": {
        start: {
          line: 43,
          column: 23
        },
        end: {
          line: 43,
          column: 47
        }
      },
      "29": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 51,
          column: 7
        }
      },
      "30": {
        start: {
          line: 45,
          column: 27
        },
        end: {
          line: 45,
          column: 36
        }
      },
      "31": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 29
        }
      },
      "32": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 38
        }
      },
      "33": {
        start: {
          line: 47,
          column: 18
        },
        end: {
          line: 47,
          column: 38
        }
      },
      "34": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 37
        }
      },
      "35": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 33
        }
      },
      "36": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 19
        }
      },
      "37": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 12
        }
      },
      "38": {
        start: {
          line: 65,
          column: 33
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "39": {
        start: {
          line: 66,
          column: 21
        },
        end: {
          line: 66,
          column: 37
        }
      },
      "40": {
        start: {
          line: 67,
          column: 26
        },
        end: {
          line: 67,
          column: 37
        }
      },
      "41": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 68,
          column: 45
        }
      },
      "42": {
        start: {
          line: 68,
          column: 28
        },
        end: {
          line: 68,
          column: 45
        }
      },
      "43": {
        start: {
          line: 69,
          column: 20
        },
        end: {
          line: 81,
          column: 3
        }
      },
      "44": {
        start: {
          line: 70,
          column: 20
        },
        end: {
          line: 70,
          column: 44
        }
      },
      "45": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "46": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 85
        }
      },
      "47": {
        start: {
          line: 74,
          column: 19
        },
        end: {
          line: 74,
          column: 51
        }
      },
      "48": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 77,
          column: 7
        }
      },
      "49": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 62
        }
      },
      "50": {
        start: {
          line: 79,
          column: 21
        },
        end: {
          line: 79,
          column: 44
        }
      },
      "51": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 27
        }
      },
      "52": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 84,
          column: 4
        }
      },
      "53": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 30
          },
          end: {
            line: 8,
            column: 31
          }
        },
        loc: {
          start: {
            line: 17,
            column: 5
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 32
          },
          end: {
            line: 18,
            column: 33
          }
        },
        loc: {
          start: {
            line: 18,
            column: 55
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 90
          },
          end: {
            line: 25,
            column: 91
          }
        },
        loc: {
          start: {
            line: 25,
            column: 100
          },
          end: {
            line: 25,
            column: 101
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 36,
            column: 54
          },
          end: {
            line: 36,
            column: 55
          }
        },
        loc: {
          start: {
            line: 36,
            column: 62
          },
          end: {
            line: 36,
            column: 66
          }
        },
        line: 36
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 39,
            column: 31
          },
          end: {
            line: 39,
            column: 32
          }
        },
        loc: {
          start: {
            line: 39,
            column: 101
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 39
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 41,
            column: 18
          },
          end: {
            line: 41,
            column: 19
          }
        },
        loc: {
          start: {
            line: 41,
            column: 44
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 41
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 42,
            column: 17
          },
          end: {
            line: 42,
            column: 18
          }
        },
        loc: {
          start: {
            line: 42,
            column: 25
          },
          end: {
            line: 52,
            column: 5
          }
        },
        line: 42
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 65,
            column: 33
          },
          end: {
            line: 65,
            column: 34
          }
        },
        loc: {
          start: {
            line: 65,
            column: 115
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 65
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 69,
            column: 20
          },
          end: {
            line: 69,
            column: 21
          }
        },
        loc: {
          start: {
            line: 69,
            column: 52
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 69
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 82,
            column: 27
          },
          end: {
            line: 82,
            column: 28
          }
        },
        loc: {
          start: {
            line: 82,
            column: 36
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 82
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 13,
            column: 16
          },
          end: {
            line: 13,
            column: 37
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 23
          },
          end: {
            line: 16,
            column: 25
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 26
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 26
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        }],
        line: 21
      },
      "4": {
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 46
          }
        }, {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 46
          }
        }],
        line: 22
      },
      "5": {
        loc: {
          start: {
            line: 25,
            column: 23
          },
          end: {
            line: 25,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 23
          },
          end: {
            line: 25,
            column: 40
          }
        }, {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 25,
            column: 46
          }
        }],
        line: 25
      },
      "6": {
        loc: {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }, {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }],
        line: 26
      },
      "7": {
        loc: {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 26,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 26,
            column: 23
          }
        }, {
          start: {
            line: 26,
            column: 27
          },
          end: {
            line: 26,
            column: 32
          }
        }],
        line: 26
      },
      "8": {
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 77
          }
        }, {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 77
          }
        }],
        line: 28
      },
      "9": {
        loc: {
          start: {
            line: 28,
            column: 10
          },
          end: {
            line: 28,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 10
          },
          end: {
            line: 28,
            column: 26
          }
        }, {
          start: {
            line: 28,
            column: 30
          },
          end: {
            line: 28,
            column: 49
          }
        }],
        line: 28
      },
      "10": {
        loc: {
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 29,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 29,
            column: 41
          }
        }, {
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 29,
            column: 41
          }
        }],
        line: 29
      },
      "11": {
        loc: {
          start: {
            line: 30,
            column: 23
          },
          end: {
            line: 30,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 30,
            column: 53
          },
          end: {
            line: 30,
            column: 76
          }
        }, {
          start: {
            line: 30,
            column: 79
          },
          end: {
            line: 30,
            column: 87
          }
        }],
        line: 30
      },
      "12": {
        loc: {
          start: {
            line: 30,
            column: 23
          },
          end: {
            line: 30,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 23
          },
          end: {
            line: 30,
            column: 41
          }
        }, {
          start: {
            line: 30,
            column: 45
          },
          end: {
            line: 30,
            column: 50
          }
        }],
        line: 30
      },
      "13": {
        loc: {
          start: {
            line: 30,
            column: 53
          },
          end: {
            line: 30,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 53
          },
          end: {
            line: 30,
            column: 70
          }
        }, {
          start: {
            line: 30,
            column: 74
          },
          end: {
            line: 30,
            column: 76
          }
        }],
        line: 30
      },
      "14": {
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 73
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 73
          }
        }, {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 73
          }
        }],
        line: 31
      },
      "15": {
        loc: {
          start: {
            line: 31,
            column: 10
          },
          end: {
            line: 31,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 10
          },
          end: {
            line: 31,
            column: 18
          }
        }, {
          start: {
            line: 31,
            column: 22
          },
          end: {
            line: 31,
            column: 27
          }
        }, {
          start: {
            line: 31,
            column: 31
          },
          end: {
            line: 31,
            column: 50
          }
        }],
        line: 31
      },
      "16": {
        loc: {
          start: {
            line: 39,
            column: 45
          },
          end: {
            line: 39,
            column: 80
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 39,
            column: 59
          },
          end: {
            line: 39,
            column: 80
          }
        }],
        line: 39
      },
      "17": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 51,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 51,
            column: 7
          }
        }, {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 51,
            column: 7
          }
        }],
        line: 44
      },
      "18": {
        loc: {
          start: {
            line: 44,
            column: 10
          },
          end: {
            line: 44,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 10
          },
          end: {
            line: 44,
            column: 18
          }
        }, {
          start: {
            line: 44,
            column: 22
          },
          end: {
            line: 44,
            column: 41
          }
        }],
        line: 44
      },
      "19": {
        loc: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 38
          }
        }, {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 38
          }
        }],
        line: 47
      },
      "20": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 45
          }
        }, {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 45
          }
        }],
        line: 68
      },
      "21": {
        loc: {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }],
        line: 71
      },
      "22": {
        loc: {
          start: {
            line: 72,
            column: 36
          },
          end: {
            line: 72,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 36
          },
          end: {
            line: 72,
            column: 78
          }
        }, {
          start: {
            line: 72,
            column: 82
          },
          end: {
            line: 72,
            column: 84
          }
        }],
        line: 72
      },
      "23": {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        }, {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        }],
        line: 75
      },
      "24": {
        loc: {
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 14
          }
        }, {
          start: {
            line: 75,
            column: 18
          },
          end: {
            line: 75,
            column: 35
          }
        }],
        line: 75
      },
      "25": {
        loc: {
          start: {
            line: 76,
            column: 38
          },
          end: {
            line: 76,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 38
          },
          end: {
            line: 76,
            column: 55
          }
        }, {
          start: {
            line: 76,
            column: 59
          },
          end: {
            line: 76,
            column: 61
          }
        }],
        line: 76
      },
      "26": {
        loc: {
          start: {
            line: 79,
            column: 21
          },
          end: {
            line: 79,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 21
          },
          end: {
            line: 79,
            column: 38
          }
        }, {
          start: {
            line: 79,
            column: 42
          },
          end: {
            line: 79,
            column: 44
          }
        }],
        line: 79
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0],
      "16": [0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import immer from 'immer';
import { deepClone } from './clone';
cov_1jvrv0avsp.s[0]++;
export var getFilterTree = function getFilterTree(treeNodes, filterFunc, filterExpandKeys, keyFunc) {
  var childrenKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : (cov_1jvrv0avsp.b[0][0]++, 'children');
  var showHitDescendants = arguments.length > 5 ? arguments[5] : undefined;
  var firstMatchNode = arguments.length > 6 ? arguments[6] : undefined;

  var _ref = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : (cov_1jvrv0avsp.b[1][0]++, {}),
      advanced = _ref.advanced;

  cov_1jvrv0avsp.f[0]++;
  cov_1jvrv0avsp.s[1]++;

  var mapFilteredNodeToData = function mapFilteredNodeToData(node) {
    cov_1jvrv0avsp.f[1]++;
    cov_1jvrv0avsp.s[2]++;

    if (!node) {
      cov_1jvrv0avsp.b[2][0]++;
      cov_1jvrv0avsp.s[3]++;
      return null;
    } else {
      cov_1jvrv0avsp.b[2][1]++;
    }

    var match = (cov_1jvrv0avsp.s[4]++, false);
    cov_1jvrv0avsp.s[5]++;

    if (filterFunc(node)) {
      cov_1jvrv0avsp.b[3][0]++;
      cov_1jvrv0avsp.s[6]++;

      if (firstMatchNode) {
        cov_1jvrv0avsp.b[4][0]++;
        cov_1jvrv0avsp.s[7]++;
        firstMatchNode(node);
      } else {
        cov_1jvrv0avsp.b[4][1]++;
      }

      cov_1jvrv0avsp.s[8]++;
      match = true;
    } else {
      cov_1jvrv0avsp.b[3][1]++;
    }

    var children = (cov_1jvrv0avsp.s[9]++, ((cov_1jvrv0avsp.b[5][0]++, node[childrenKey]) || (cov_1jvrv0avsp.b[5][1]++, [])).map(mapFilteredNodeToData).filter(function (n) {
      cov_1jvrv0avsp.f[2]++;
      cov_1jvrv0avsp.s[10]++;
      return n;
    }));
    cov_1jvrv0avsp.s[11]++;

    if ((cov_1jvrv0avsp.b[7][0]++, children.length) || (cov_1jvrv0avsp.b[7][1]++, match)) {
      cov_1jvrv0avsp.b[6][0]++;
      var key = (cov_1jvrv0avsp.s[12]++, keyFunc(node));
      cov_1jvrv0avsp.s[13]++;

      if ((cov_1jvrv0avsp.b[9][0]++, filterExpandKeys) && (cov_1jvrv0avsp.b[9][1]++, children.length > 0)) {
        cov_1jvrv0avsp.b[8][0]++;
        cov_1jvrv0avsp.s[14]++;
        filterExpandKeys.push(key);
      } else {
        cov_1jvrv0avsp.b[8][1]++;
      }

      cov_1jvrv0avsp.s[15]++;

      if (!node[childrenKey]) {
        cov_1jvrv0avsp.b[10][0]++;
        cov_1jvrv0avsp.s[16]++;
        return node;
      } else {
        cov_1jvrv0avsp.b[10][1]++;
      }

      var childNodes = (cov_1jvrv0avsp.s[17]++, (cov_1jvrv0avsp.b[12][0]++, showHitDescendants) && (cov_1jvrv0avsp.b[12][1]++, match) ? (cov_1jvrv0avsp.b[11][0]++, (cov_1jvrv0avsp.b[13][0]++, node[childrenKey]) || (cov_1jvrv0avsp.b[13][1]++, [])) : (cov_1jvrv0avsp.b[11][1]++, children));
      cov_1jvrv0avsp.s[18]++;

      if ((cov_1jvrv0avsp.b[15][0]++, advanced) && (cov_1jvrv0avsp.b[15][1]++, match) && (cov_1jvrv0avsp.b[15][2]++, children.length > 0)) {
        cov_1jvrv0avsp.b[14][0]++;
        cov_1jvrv0avsp.s[19]++;
        childNodes = children;
      } else {
        cov_1jvrv0avsp.b[14][1]++;
      }

      cov_1jvrv0avsp.s[20]++;
      return _objectSpread2(_objectSpread2({}, node), {}, _defineProperty({}, childrenKey, childNodes));
    } else {
      cov_1jvrv0avsp.b[6][1]++;
    }

    cov_1jvrv0avsp.s[21]++;
    return null;
  };

  cov_1jvrv0avsp.s[22]++;
  return treeNodes.map(mapFilteredNodeToData).filter(function (node) {
    cov_1jvrv0avsp.f[3]++;
    cov_1jvrv0avsp.s[23]++;
    return node;
  });
};
cov_1jvrv0avsp.s[24]++;
export var getFlattenTree = function getFlattenTree(data) {
  var childrenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1jvrv0avsp.b[16][0]++, 'children');
  var wide = arguments.length > 2 ? arguments[2] : undefined;
  cov_1jvrv0avsp.f[4]++;
  var arr = (cov_1jvrv0avsp.s[25]++, []);
  cov_1jvrv0avsp.s[26]++;

  var flatten = function flatten(list, path) {
    cov_1jvrv0avsp.f[5]++;
    cov_1jvrv0avsp.s[27]++;
    list.forEach(function (item) {
      cov_1jvrv0avsp.f[6]++;
      var children = (cov_1jvrv0avsp.s[28]++, item[childrenKey]);
      cov_1jvrv0avsp.s[29]++;

      if ((cov_1jvrv0avsp.b[18][0]++, children) && (cov_1jvrv0avsp.b[18][1]++, children.length > 0)) {
        cov_1jvrv0avsp.b[17][0]++;
        var clonedPath = (cov_1jvrv0avsp.s[30]++, _toConsumableArray(path));
        cov_1jvrv0avsp.s[31]++;
        clonedPath.push(item);
        cov_1jvrv0avsp.s[32]++;

        if (wide) {
          cov_1jvrv0avsp.b[19][0]++;
          cov_1jvrv0avsp.s[33]++;
          arr.push(clonedPath);
        } else {
          cov_1jvrv0avsp.b[19][1]++;
        }

        cov_1jvrv0avsp.s[34]++;
        flatten(children, clonedPath);
      } else {
        cov_1jvrv0avsp.b[17][1]++;
        cov_1jvrv0avsp.s[35]++;
        arr.push([].concat(_toConsumableArray(path), [item]));
      }
    });
  };

  cov_1jvrv0avsp.s[36]++;
  flatten(data, []);
  cov_1jvrv0avsp.s[37]++;
  return arr;
};
cov_1jvrv0avsp.s[38]++;
export var mergeFilteredTree = function mergeFilteredTree(filterDatum, rawDatum, tiledId) {
  cov_1jvrv0avsp.f[7]++;
  var filterData = (cov_1jvrv0avsp.s[39]++, filterDatum.data);

  var _ref2 = (cov_1jvrv0avsp.s[40]++, filterDatum),
      childrenKey = _ref2.childrenKey;

  cov_1jvrv0avsp.s[41]++;

  if (tiledId.length === 0) {
    cov_1jvrv0avsp.b[20][0]++;
    cov_1jvrv0avsp.s[42]++;
    return filterData;
  } else {
    cov_1jvrv0avsp.b[20][1]++;
  }

  cov_1jvrv0avsp.s[43]++;

  var recursion = function recursion(node) {
    cov_1jvrv0avsp.f[8]++;
    var nodeKey = (cov_1jvrv0avsp.s[44]++, filterDatum.getKey(node));
    cov_1jvrv0avsp.s[45]++;

    if (tiledId.indexOf(nodeKey) >= 0) {
      cov_1jvrv0avsp.b[21][0]++;
      cov_1jvrv0avsp.s[46]++;
      node[childrenKey] = deepClone((cov_1jvrv0avsp.b[22][0]++, rawDatum.getDataById(nodeKey)[childrenKey]) || (cov_1jvrv0avsp.b[22][1]++, []));
    } else {
      cov_1jvrv0avsp.b[21][1]++;
      var item = (cov_1jvrv0avsp.s[47]++, filterDatum.getDataById(nodeKey));
      cov_1jvrv0avsp.s[48]++;

      if ((cov_1jvrv0avsp.b[24][0]++, item) && (cov_1jvrv0avsp.b[24][1]++, item[childrenKey])) {
        cov_1jvrv0avsp.b[23][0]++;
        cov_1jvrv0avsp.s[49]++;
        node[childrenKey] = deepClone((cov_1jvrv0avsp.b[25][0]++, item[childrenKey]) || (cov_1jvrv0avsp.b[25][1]++, []));
      } else {
        cov_1jvrv0avsp.b[23][1]++;
      }
    }

    var children = (cov_1jvrv0avsp.s[50]++, (cov_1jvrv0avsp.b[26][0]++, node[childrenKey]) || (cov_1jvrv0avsp.b[26][1]++, []));
    cov_1jvrv0avsp.s[51]++;
    children.map(recursion);
  };

  cov_1jvrv0avsp.s[52]++;
  return immer(filterData, function (draft) {
    cov_1jvrv0avsp.f[9]++;
    cov_1jvrv0avsp.s[53]++;
    draft.map(recursion);
  });
};